var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShadcncraft = function SvgShadcncraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.518 1.292v5.67H8.178l-3.612 6.073a.78.78 0 0 1-.675.383H.785A.786.786 0 0 1 0 12.632v-5.67h7.602l3.154-5.304A2.35 2.35 0 0 1 12.781.507h7.952c.433 0 .785.352.785.785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 20.6v-5.67h13.34l3.612-6.072a.78.78 0 0 1 .676-.383h3.107c.433 0 .785.352.785.785v5.67h-7.602l-3.154 5.305a2.35 2.35 0 0 1-2.025 1.15H.785A.786.786 0 0 1 0 20.6"
  })));
};
export default SvgShadcncraft;